import clienteAxios from "../../../config/axios";

const fileUpload = async (file, carpeta = "documentos") => {
  try {
    const formData = new FormData();
    await formData.append("archivo", file);
    formData.append("carpeta", carpeta);
    const res = await clienteAxios.post("/archivos/subir", formData);
    return { url: res?.data?.url || "" };
  } catch (error) {
    return "";
  }
};
export const uploadImagesHelper = async (imagenes, fotosSubidas, carpeta) => {
  const fileUploadPromises = [];
  for (const file of imagenes) {
    fileUploadPromises.push(fileUpload(file, carpeta));
  }

  const photosUrls = await Promise.all(fileUploadPromises);
  if (fotosSubidas.length > 0) {
    try {
      await clienteAxios.delete("/archivos/eliminar", {
        data: {
          urls: fotosSubidas
            .map((item) => item.url)
            .filter((itemE) => itemE !== ""),
        },
      });
    } catch (error) {}
  }

  return { data: { urls: photosUrls } };
};
